module.exports = __webpack_public_path__ + "img/chat-4.3cfb9335.svg";